"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VM_RUNTIME = exports.VM_SEPARATORS = exports.VM_SPECIAL_VARS = void 0;
exports.isSpecialVariable = isSpecialVariable;
exports.isScopedVariable = isScopedVariable;
exports.getScopedVariableName = getScopedVariableName;
exports.parseScopedVariableName = parseScopedVariableName;
exports.VM_SPECIAL_VARS = {
    capturedThis: '__this__',
    capturedArguments: '__arguments__',
    arrowRestParam: '__vm_rest__',
};
exports.VM_SEPARATORS = {
    blockScope: '$$',
};
exports.VM_RUNTIME = {
    executorPrefix: '_vm_exec',
};
function isSpecialVariable(name) {
    return Object.values(exports.VM_SPECIAL_VARS).includes(name);
}
function isScopedVariable(name) {
    return name.includes(exports.VM_SEPARATORS.blockScope);
}
function getScopedVariableName(baseName, depth) {
    return `${baseName}${exports.VM_SEPARATORS.blockScope}${depth}`;
}
function parseScopedVariableName(scopedName) {
    const parts = scopedName.split(exports.VM_SEPARATORS.blockScope);
    if (parts.length !== 2) {
        return null;
    }
    const depth = parseInt(parts[1], 10);
    if (isNaN(depth)) {
        return null;
    }
    return { baseName: parts[0], depth };
}
